import React from "react";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { SETTINGS } from "@/constants/testIds";

// Small helper to declutter the JSX: each row is `label + input`.
function Field({ label, value, onChange, placeholder, testId, colSpan = "" }) {
  return (
    <div className={`space-y-1.5 ${colSpan}`}>
      <Label className="text-xs font-semibold uppercase tracking-wider text-slate-700">{label}</Label>
      <Input
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        className="focus-visible:ring-orange-500"
        data-testid={testId}
      />
    </div>
  );
}

export function BrandingSettings({ branding, setBranding, onSave }) {
  const set = (patch) => setBranding({ ...branding, ...patch });
  return (
    <Card className="p-6 border-slate-200 shadow-sm">
      <h3 className="text-base font-semibold text-slate-900 mb-4">Identidad institucional</h3>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <Field label="Empresa" value={branding.company_name || ""}
          onChange={(e) => set({ company_name: e.target.value })} />
        <Field label="Sitio web" value={branding.website || ""}
          onChange={(e) => set({ website: e.target.value })} />
        <Field label="Eslogan" value={branding.slogan || ""}
          onChange={(e) => set({ slogan: e.target.value })} colSpan="md:col-span-2" />
        <Field label="Dirección" value={branding.address || ""}
          onChange={(e) => set({ address: e.target.value })} colSpan="md:col-span-2" />
        <Field label="URL Logo" value={branding.logo_url || ""}
          onChange={(e) => set({ logo_url: e.target.value })} placeholder="https://..." />
        <Field label="Color primario" value={branding.primary_color || ""}
          onChange={(e) => set({ primary_color: e.target.value })} placeholder="#ea580c" />
      </div>

      {/* -------- Redes sociales -------- */}
      <div className="mt-8 pt-6 border-t border-slate-200">
        <div className="flex items-center justify-between mb-4">
          <div>
            <h4 className="text-sm font-semibold text-slate-900">Redes sociales</h4>
            <p className="text-xs text-slate-500 mt-0.5">
              Los iconos aparecerán en la firma solo para las redes con URL configurada. Estilo minimalista monocromo.
            </p>
          </div>
          <div className="flex items-center gap-2">
            <Label className="text-xs font-semibold uppercase tracking-wider text-slate-700">Color</Label>
            <input
              type="color"
              value={`#${(branding.social_icon_color || "ea580c").replace(/^#/, "")}`}
              onChange={(e) => set({ social_icon_color: e.target.value.replace(/^#/, "") })}
              className="h-8 w-12 rounded border border-slate-300 cursor-pointer"
              data-testid="branding-social-color"
              title="Color de los iconos sociales"
            />
          </div>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <Field label="Facebook" value={branding.facebook_url || ""}
            onChange={(e) => set({ facebook_url: e.target.value })}
            placeholder="https://facebook.com/hospital" testId="branding-facebook-url" />
          <Field label="Instagram" value={branding.instagram_url || ""}
            onChange={(e) => set({ instagram_url: e.target.value })}
            placeholder="https://instagram.com/hospital" testId="branding-instagram-url" />
          <Field label="LinkedIn" value={branding.linkedin_url || ""}
            onChange={(e) => set({ linkedin_url: e.target.value })}
            placeholder="https://linkedin.com/company/hospital" testId="branding-linkedin-url" />
          <Field label="X (Twitter)" value={branding.x_url || ""}
            onChange={(e) => set({ x_url: e.target.value })}
            placeholder="https://x.com/hospital" testId="branding-x-url" />
          <Field label="WhatsApp" value={branding.whatsapp_url || ""}
            onChange={(e) => set({ whatsapp_url: e.target.value })}
            placeholder="https://wa.me/57XXXXXXXXXX" testId="branding-whatsapp-url"
            colSpan="md:col-span-2" />
        </div>
      </div>
      <div className="mt-6 flex justify-end">
        <Button onClick={onSave} className="bg-orange-600 hover:bg-orange-700 text-white"
          data-testid={SETTINGS.saveBrandingBtn}>
          Guardar identidad
        </Button>
      </div>
    </Card>
  );
}
